// Initiate foundation
jQuery(document).foundation();

// Main setup functions
jQuery(document).ready(function ($) {

  console.log('Hello from OASIS main.js');

  // Smooth scrolling to anchors
	$('a[href*="#"]')
  .not('[href="#"]')
  .not('[href="#_"]')
  .click(function (event) {
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - 100
        }, 1000);
      }
    }
  });
// all mobile menu toggle buttons
  $('button.menu-toggle').click(function (event) {
    event.preventDefault();
    $('#mobile-menu').toggleClass('toggle');
    $('#main-menu-toggle').toggleClass('toggle');
  });
// main site mobile menu
  $('#mobile-menu > ul#main-menu:not(.sub-menu) > li.menu-item.menu-item-has-children > a').click(function (event) {
    event.preventDefault();
    $(this).parent().toggleClass('toggle');
    $('#mobile-menu').toggleClass('sub-menu');
  });
  $('#mobile-menu p.menu-back').click(function (event) {
    event.preventDefault();
    $('#mobile-menu').removeClass('sub-menu');
    $('#mobile-menu ul#main-menu > li.menu-item').removeClass('toggle');
    $('#mobile-menu ul#menu-member-sidebar > li.menu-item').removeClass('toggle');
  });
// members area mobile menu
$('#mobile-menu ul#menu-member-sidebar:not(.sub-menu) > li.menu-item.menu-item-has-children > a').click(function (event) {
  event.preventDefault();
  $(this).parent().toggleClass('toggle');
  $('#mobile-menu').toggleClass('sub-menu');
});


// mainly for members home header
//$(window).scroll(function(){
//    if ($(this).scrollTop() > 50) {
//       $('body').addClass('scrolled');
//    } else {
//       $('body').removeClass('scrolled');
//    }
// });

// fix sidebar on scroll
// $.fn.scrollBottom = function() { 
//  return $(document).height() - this.scrollTop() - this.height(); 
// };

// $(window).scroll(function(){
//   if ($(this).scrollTop() > 199 && $(this).scrollBottom() > 400) {
//      $('.job-listing').addClass('scrolled');
//      $('.sidebar-margin').addClass('scrolled');
//      $('.sidebar-margin-2').addClass('scrolled');
//   } 
  
//   if ( $(this).scrollTop() < 200  || $(this).scrollBottom() < 100 ) {
//      $('.job-listing').removeClass('scrolled');
//      $('.sidebar-margin').removeClass('scrolled');
//   }
// different bottom margin on member application page
//   if ( $(this).scrollTop() < 200 || $(this).scrollBottom() < 100 ) {
//     $('.sidebar-margin-2').removeClass('scrolled');
//  }


//});

// add class top dropdown when selected
$(function(){
  $(".wpcf7-select").change(function(){
    var status = this.value;
    if(status!="") $(this).addClass('selected');
    if(status=="") $(this).removeClass('selected');// hide multiple sections
   });
 
 });

 // center login screen vertically
 $(window).resize(function(){
  $('body.login').css({
      position:'absolute',
      left: ($(window).width() - $('.className').outerWidth())/2,
      top: ($(window).height() - $('.className').outerHeight())/2
  });
});
$(window).resize();

});
